import { render, staticRenderFns } from "./matching-list-interests.vue?vue&type=template&id=8e2f7b6e&scoped=true&"
import script from "./matching-list-interests.vue?vue&type=script&lang=ts&"
export * from "./matching-list-interests.vue?vue&type=script&lang=ts&"
import style0 from "./matching-list-interests.vue?vue&type=style&index=0&id=8e2f7b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2f7b6e",
  null
  
)

export default component.exports